import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const ServicesCTA = () => {
  const navigate = useNavigate();

  return (
    <section style={{ padding: '80px 24px', background: 'rgba(255,87,34,0.04)', borderTop: '1px solid rgba(255,87,34,0.12)' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '64px', alignItems: 'center' }} className="services-grid">
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
              <span style={{ fontFamily: 'var(--font-heading)', fontSize: '11px', fontWeight: 600, letterSpacing: '0.16em', textTransform: 'uppercase', color: '#FF5722' }}>Kom i gang</span>
              <div style={{ width: '60px', height: '1px', background: 'rgba(255,87,34,0.3)' }} />
            </div>
            <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: '32px', fontWeight: 700, color: 'var(--color-foreground)', letterSpacing: '0.02em', marginBottom: '16px', lineHeight: 1.2 }}>
              Klar til å spare på bomkostnader?
            </h2>
            <p style={{ fontFamily: 'var(--font-body)', fontSize: '16px', color: 'var(--color-muted-foreground)', lineHeight: 1.7, marginBottom: '32px' }}>
              Registrer deg gratis og se hvor mye du kan spare. Ingen kredittkort kreves for prøveperioden på 30 dager.
            </p>
            <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
              <motion.button whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.97 }}
                onClick={() => navigate('/register')}
                style={{ background: '#FF5722', border: '2px solid #FF5722', borderRadius: '2px', padding: '14px 32px', fontFamily: 'var(--font-heading)', fontSize: '13px', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#FFFFFF', cursor: 'pointer' }}>
                Start gratis prøveperiode
              </motion.button>
              <motion.button whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.97 }}
                onClick={() => navigate('/contact')}
                style={{ background: 'transparent', border: '1px solid rgba(224,228,232,0.2)', borderRadius: '2px', padding: '14px 32px', fontFamily: 'var(--font-heading)', fontSize: '13px', fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'var(--color-foreground)', cursor: 'pointer' }}>
                Kontakt salg
              </motion.button>
            </div>
          </div>

          {/* Stats */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
            {[
              { value: '12 400+', label: 'Aktive brukere', sub: 'Privatpersoner og bedrifter' },
              { value: 'kr 2.1M', label: 'Spart totalt', sub: 'Av våre kunder i 2024' },
              { value: '99.9%', label: 'Oppetid', sub: 'Garantert SLA' },
              { value: '4.8/5', label: 'Kundevurdering', sub: 'Basert på 1 200 anmeldelser' },
            ]?.map((stat, i) => (
              <motion.div key={stat?.label} initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}
                style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(224,228,232,0.08)', borderRadius: '2px', padding: '24px' }}>
                <div style={{ fontFamily: 'var(--font-heading)', fontSize: '24px', fontWeight: 700, color: '#FF5722', marginBottom: '4px' }}>{stat?.value}</div>
                <div style={{ fontFamily: 'var(--font-heading)', fontSize: '14px', fontWeight: 600, color: 'var(--color-foreground)', marginBottom: '4px' }}>{stat?.label}</div>
                <div style={{ fontFamily: 'var(--font-body)', fontSize: '12px', fontWeight: 300, color: 'var(--color-muted-foreground)' }}>{stat?.sub}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesCTA;
